// eslint-disable-next-line import/no-anonymous-default-export
export default {
    "car-brands": {
        fields: {
            name: 'Name',
        },
    },
}